import { render, staticRenderFns } from "./AutoCampaignRuns.vue?vue&type=template&id=bd15a218&scoped=true&"
import script from "./AutoCampaignRuns.vue?vue&type=script&lang=js&"
export * from "./AutoCampaignRuns.vue?vue&type=script&lang=js&"
import style0 from "./AutoCampaignRuns.vue?vue&type=style&index=0&id=bd15a218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd15a218",
  null
  
)

export default component.exports